import { useEffect } from 'react';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { ReactComponent as RappiLogo } from 'assets/images/logos/rappi_logo_to_print.svg';

import { formatCurrency } from '../../utils/CurrencyUtils';

import makeClasses from './SummarySalesBill.style';

function SummarySalesBill(props) {
  const {
    cancelOrders,
    canceledTitle,
    date,
    finishedTitle,
    finishOrders,
    onPrint,
    ordersTitle,
    pendingToPrint,
    selectedDate,
    selectedStore,
    showCancelOrderDiscount,
    showFinishOrderDiscount,
    showTotalCancelOrderWithDiscount,
    showTotalFinishOrderWithDiscount,
    storeName,
    SummarySales,
    totalAccumulated,
    langDiscountsByPartnerStore,
    langTotalStore,
    langDiscountsByRappi,
    totalDiscount,
    totalWithDiscount,
  } = props;

  const _classes = makeClasses();

  useEffect(() => {
    if (pendingToPrint) {
      onPrint();
      window.print();
    }
  }, [pendingToPrint]);

  if (!pendingToPrint) return null;
  return (
    <div className={_classes.root} aria-label='old SummarySalesBill'>
      <div className={_classes.container}>
        <RappiLogo />
      </div>
      <div className={_classes.blackLine}>{SummarySales}</div>
      <span>
        {storeName} : {selectedStore.name}
      </span>
      <br></br>
      <span>
        {date}: {selectedDate}
      </span>
      <div className={_classes.container}>
        <div className={_classes.blackLine}>{finishedTitle}</div>
        <div>
          {ordersTitle}:&nbsp;
          {finishOrders?.number_of_finished_orders}
        </div>
        <div className={_classes.container}>
          <div>
            {totalAccumulated}:&nbsp;
            {formatCurrency(finishOrders?.total_accumulated)}
          </div>
          <p>
            {langDiscountsByPartnerStore}:&nbsp; -
            {formatCurrency(finishOrders?.discounts_partner_store ?? 0, false)}
          </p>
          <div>
            {langTotalStore}:&nbsp;
            {formatCurrency(finishOrders?.total_restaurant ?? 0)}
          </div>
          <p>
            {langDiscountsByRappi}:&nbsp; -
            {formatCurrency(finishOrders?.discounts_rappi ?? 0, false)}
          </p>
          {showFinishOrderDiscount && (
            <div>
              {totalDiscount}:&nbsp;
              {formatCurrency(finishOrders?.discounts)}
            </div>
          )}
          {showTotalFinishOrderWithDiscount && (
            <div>
              {totalWithDiscount}:&nbsp;
              {formatCurrency(finishOrders?.total_with_discounts)}
            </div>
          )}
        </div>
      </div>
      <div className={_classes.container}>
        <div className={_classes.blackLine}>{canceledTitle}</div>
        <div>
          {ordersTitle}:&nbsp;
          {cancelOrders?.number_of_finished_orders}
        </div>
        <div className={_classes.container}>
          <div>
            {totalAccumulated}:&nbsp;
            {formatCurrency(cancelOrders?.total_accumulated)}
          </div>
          <p>
            {langDiscountsByPartnerStore}:&nbsp; -
            {formatCurrency(cancelOrders?.discounts_partner_store ?? 0, false)}
          </p>
          <p>
            {langDiscountsByRappi}:&nbsp; -
            {formatCurrency(cancelOrders?.discounts_rappi ?? 0, false)}
          </p>
          {showCancelOrderDiscount && (
            <div>
              {totalDiscount}:&nbsp;
              {formatCurrency(cancelOrders?.discounts)}
            </div>
          )}
          {showTotalCancelOrderWithDiscount && (
            <div>
              {totalWithDiscount}:&nbsp;
              {formatCurrency(cancelOrders?.total_with_discounts)}
            </div>
          )}
        </div>
        <div className={_classes.blackLine}>&nbsp;</div>
      </div>
      <h1>
        <div className={_classes.blackLine}>
          <span className={_classes.left}>
            <KeyboardArrowRight />
          </span>
          <span className={_classes.right}>
            <KeyboardArrowLeft />
          </span>
        </div>
      </h1>
    </div>
  );
}

export default SummarySalesBill;
